export const ExitIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 22 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.7645 25C9.22364 25 5.5293 21.3081 5.5293 16.77C5.5293 16.262 5.94143 15.8505 6.44969 15.8505C6.95796 15.8505 7.37009 16.262 7.37009 16.77C7.37009 20.2937 10.2387 23.1604 13.7645 23.1604C17.2906 23.1604 20.1592 20.2937 20.1592 16.77V8.22975C20.1592 4.70628 17.2906 1.83957 13.7645 1.83957C10.2387 1.83957 7.37009 4.70628 7.37009 8.22975C7.37009 8.73768 6.95796 9.14954 6.44969 9.14954C5.94143 9.14954 5.5293 8.73768 5.5293 8.22975C5.5293 3.6919 9.22364 1.90735e-06 13.7645 1.90735e-06C18.3054 1.90735e-06 22 3.6919 22 8.22975V16.77C22 21.3081 18.3054 25 13.7645 25Z"
        fill="#001E64"
      />
      <path
        d="M11.367 13.3497C9.21526 13.3497 2.95852 13.3521 0.943256 13.3482C0.356362 13.347 -0.00236198 13.0147 1.17074e-05 12.4972C0.00268211 11.9819 0.361703 11.6578 0.953641 11.6569C2.8155 11.6531 8.91885 11.6554 10.781 11.6554H11.3569C10.8617 11.16 10.4407 10.7395 10.0199 10.3184C9.83094 10.129 9.63155 9.94781 9.45649 9.74588C9.14079 9.38146 9.16334 8.88006 9.49328 8.56457C9.80928 8.26212 10.3 8.24255 10.6439 8.55449C11.0092 8.88569 11.348 9.24596 11.6972 9.59436C12.4257 10.322 13.1559 11.0476 13.8807 11.7785C14.3929 12.2947 14.3911 12.714 13.8736 13.2338C12.8589 14.2535 11.8406 15.2693 10.822 16.2846C10.3629 16.7418 9.85645 16.7955 9.48557 16.4332C9.11171 16.0676 9.15651 15.5531 9.60929 15.0988C10.1638 14.5423 10.7228 13.9905 11.367 13.3497Z"
        fill="#001E64"
      />
    </svg>
  );
};
